






























































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  formatJson,
  resetObjValue2NoneString,
  checkNoneString,
  deepCopy,
  copyFields
} from '@/utils/tool'
import { getFeedbackList, exportFeedbackList, replyFeedback } from '@/api/feedback/feedback'
import { Form } from 'element-ui'
import baseUrl from '@/utils/envConfig'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { EApprovalColor } from '@/typings/enum'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'
import ApprovalPopup from './components/approval-popup.vue'

type actStatus = 'open' | 'close'
interface info {
    applicant: string,
    type: string,
    typeId: number,
    status: string,
    statusId: number
  }

const statisticList = [
  {
    name: '待审核',
    count: 1256
  },
  {
    name: '已审核',
    count: 43
  }
]
const typeList = [
  {
    id: '',
    name: '全部'
  },
  {
    id: 0,
    name: '其他'
  },
  {
    id: 1,
    name: '需要更新'
  },
  {
    id: 2,
    name: '无法安装'
  },
  {
    id: 3,
    name: '打开闪退'
  },
  {
    id: 4,
    name: '玩一会儿闪退'
  },
  {
    id: 5,
    name: '游戏账号'
  },
  {
    id: 6,
    name: '游戏充值'
  },
  {
    id: 7,
    name: '与描述不符'
  }
]
const statusList = [
  {
    'id': 0,
    'name': '全部'
  },
  {
    'id': 1,
    'name': '兔兔本体'
  },
  {
    'id': 2,
    'name': '普通应用'
  }
]

const feedbackPlatforms = [
  {
    id: '',
    name: '全部'
  },
  {
    id: 1,
    name: '安卓客户端'
  },
  {
    id: 2,
    name: 'iOS客户端'
  },
  {
    id: 3,
    name: '安卓官网'
  },
  {
    id: 4,
    name: 'iOS官网'
  },
  {
    id: 5,
    name: 'PC官网'
  }
]

@Component({
  name: 'ApprovalList',
  components: {
    ApprovalPopup
  }
})
export default class extends mixins(DateOption) {
  // api data
  params = {
    id: '',
    isSetEntity: 0,
    type: '',
    start: '',
    end: '',
    platform: '',
    page: 1,
    pageCount: 20
  }

  // component data
  stateColor = EApprovalColor
  rules: any = {
    content: [{ required: true, message: '请输入反馈', trigger: 'blur' }]
  }
  statisticList = statisticList
  tableLoading = false
  tableData: any[] = []
  typeList: any[] = typeList
  statusList: any[] = statusList
  dateArray: string[] = ['', '']
  totalCount = 0
  platforms: any[] = feedbackPlatforms

  feedbackParams: any = {
    id: '',
    content: ''
  }
  approveInfo:info = {
    applicant: '',
    type: '',
    typeId: 1,
    status: '',
    statusId: 1
  }
  tableHeight = 500
  visible = false

  // lifecycle
  async created() {
    this.getTableData()
  }

  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getFeedbackList(this.params)
    let dataList = res.data.dataList || []
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    this.tableLoading = false
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.image = []
      this.tableData.push(el)
    })
    this.totalCount = res.data.pageInfo.totalCount
    for (let i = 0; i < dataList.length; i++) {
      let image = []
      if (dataList[i].image) {
        image = JSON.parse(dataList[i].image)
      }
      if (image.length > 0) {
        let all = image.map((item: string) => getImgURLOfBase64(item, header))
        Promise.all(all).then(arr => {
          this.tableData[i]['image'] = arr
        }).catch(err => {
          console.log(err)
        })
      }
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }

  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }

  handleDateChange(date: string[]) {
    this.params.start = date && date[0]
    this.params.end = date && date[1]
    this.handleSearch()
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArray = ['', '']
    this.params.page = 1
    this.handleSearch()
  }

  cancelReply() {
    this.visible = false
  }

  async confirmReply() {
    if (this.feedbackParams.content.length <= 0) return this.$message.warning('请输入反馈内容')
    console.log(this.feedbackParams)
    let res: any = await replyFeedback({
      id: this.feedbackParams.id,
      content: this.feedbackParams.content
    })
    if (~~res.status.code === 0) {
      this.$message.success('操作成功')
      this.visible = false
    }
  }

  handleReply(item: any) {
    this.feedbackParams.id = item.id
    this.feedbackParams.content = ''
    this.visible = true
    // copyFields(this.approveInfo, item)
  }

  setParams(params: any) {
    let arr = []
    for (let key in params) {
      arr.push(key + '=' + params[key])
    }
    return arr.join('&')
  }

  handleExcel() {
    location.href = baseUrl + '/feedback/export?' + this.setParams(this.params)
  }
}
